"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TestId = void 0;
let TestId = exports.TestId = /*#__PURE__*/function (TestId) {
  // Dialog with account balance informations
  TestId["AccountBalanceDialog"] = "account-balance-dialog";
  // Additional info containing add voucher and account balance buttons
  TestId["AdditionalInfo"] = "additional-info";
  // Add voucher button
  TestId["AddVoucherButton"] = "add-voucher-button";
  // Cashback and bonus info
  TestId["CashbackAndBonus"] = "cashback-and-bonus";
  // Continue button
  TestId["ContinueButton"] = "continue-button";
  // Delivery fee
  TestId["Delivery"] = "delivery";
  // Personal discount
  TestId["Discount"] = "discount";
  // Summary fee
  TestId["Fee"] = "fee";
  // Finalise order button
  TestId["FinaliseOrderButton"] = "finalise-order-button";
  // Loading screen for pending order
  TestId["LoadingScreen"] = "loading-screen";
  // Login button
  TestId["LoginButton"] = "login-button";
  // Prepaid
  TestId["Prepaid"] = "prepaid";
  // Register button
  TestId["RegisterButton"] = "register-button";
  // Sticky panel
  TestId["StickyPanel"] = "sticky-panel";
  // Subtotal
  TestId["Subtotal"] = "subtotal";
  // Summary
  TestId["Summary"] = "summary";
  // Skeleton for Summary
  TestId["SummarySkeleton"] = "summary-skeleton";
  // Consent for terms and conditions
  TestId["TermsAndConditionsConsent"] = "terms-and-conditions-consent";
  // Summary title
  TestId["Title"] = "title";
  // Debt to pay
  TestId["ToPay"] = "to-pay";
  // Voucher line in summary
  TestId["Voucher"] = "voucher";
  // Vouchers error exclamation mark
  TestId["VouchersExclamationMark"] = "vouchers-exclamation-mark";
  // Input in vouchers dialog
  TestId["VouchersInput"] = "vouchers-input";
  // Wallet payment
  TestId["WalletPayment"] = "wallet-payment";
  return TestId;
}({});